import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { ProgramListComponent } from './program-list.component';
import { ListOfProgramsComponent } from './list-of-programs/list-of-programs.component';
import { PlayerViewModule } from '@app/player-view/player-view.module';

@NgModule({
  declarations: [
    ProgramListComponent,
    ListOfProgramsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    PlayerViewModule,
  ]
})
export class ProgramListModule { }
